import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

import { useDAL } from '@/contexts/useDAL';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';

import { EmptySelect } from './emptySelect';

export const NetworkInterfaceSelect = ({
  accountId,
  resourceGroup,
  networkInterface,
  location,
  onChange,
}: {
  accountId?: string;
  resourceGroup?: string;
  networkInterface?: string;
  location?: string;
  onChange: (networkInterface: string) => void;
}) => {
  const { RestoreVmWithNoNic } = useFeatureFlags();
  const title = `Network Interface${RestoreVmWithNoNic ? ' (optional)' : ''}`;
  if (!accountId || !resourceGroup || !location) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerNetworkInterfaceSelect
      accountId={accountId}
      resourceGroup={resourceGroup}
      networkInterface={networkInterface}
      location={location}
      onChange={onChange}
      title={title}
    />
  );
};

const InnerNetworkInterfaceSelect = ({
  accountId,
  resourceGroup,
  networkInterface,
  location,
  onChange,
  title,
}: {
  accountId: string;
  resourceGroup: string;
  networkInterface?: string;
  location: string;
  onChange: (networkInterface: string) => void;
  title: string;
}) => {
  const dal = useDAL();
  const { data: body } =
    dal.restore.azureRestoreConfig.useListNetworkInterfaces(
      accountId,
      resourceGroup
    );
  const regionNics = body?.networkInterfaces
    .filter((ni) => ni.location === location)
    .map((ni) => ni.name);
  if (!regionNics?.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        clearOnBlur
        size='small'
        value={networkInterface || null}
        onChange={(event, newValue) => onChange(newValue || '')}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              InputLabelProps={{ shrink: true }}
            />
          );
        }}
        options={regionNics}
      />
    </FormControl>
  );
};
